import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ChildPolicyDislay } from 'app/model/products/product-detail-info.model';
import { TranslatePipe } from 'app/pipes/translate.pipe';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Language } from 'app/model/constant';
import { Subscription } from 'rxjs/Subscription';
import { Remark, ChildPolicy} from 'app/model/products/product-detail-info.model'

@Component({
  selector: 'act-hotel-remark-information',
  templateUrl: './hotel-remark-information.component.html',
  styleUrls: ['./hotel-remark-information.component.scss']
})
export class HotelRemarkInformationComponent implements OnInit, OnDestroy {

  @Input('page')
  page: String;

  @Input('minGuestAge') set setMinGuestAge(minGuestAge: number) {
    if (this.minGuestAge && this.minGuestAge > 0) {
      this.minGuestAge = minGuestAge;
      this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age');
      this.minGuestDisplay = this.minGuestDisplay.replace('{x}', this.minGuestAge.toString());
    } else {
      this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age-all-age');
    }
  }

  @Input('childPolicies') set setChildPolicies(childPolicies: ChildPolicy[]) {
    if (childPolicies) {
      this.childPolicies = childPolicies;
      this.transformChildPolicyForDisplay();
    }
  }

  @Input('hotelRemarks') set setHotelRemarks(hotelRemarks: Remark[]) {
    if (hotelRemarks) {
      this.hotelRemarks = hotelRemarks;
      this.transformHotelRemarkForDisplay();
    }
  }
  private languageSubscription: Subscription;

  private minGuestAge: number;
  private childPolicies: ChildPolicy[] = [];
  private hotelRemarks: Remark[] = [];

  private minGuestDisplay: String;
  private hotelRemarksDisplay: String[] = [];
  private childPolicyDisplay: ChildPolicyDislay[] = [];


  constructor(
    private translate: TranslatePipe,
    private appConfigService: AppConfigService
  ) { }

  ngOnInit() {
    this.languageSubscription = this.appConfigService.getLanguageObs()
      .subscribe(lang => {
        this.transformChildPolicyForDisplay();
        this.transformHotelRemarkForDisplay();
        if (this.minGuestAge > 0) {
          this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age');
          this.minGuestDisplay = this.minGuestDisplay.replace('{x}', this.minGuestAge.toString());
        } else {
          this.minGuestDisplay = this.translate.transform('child-policy-min-guest-age-all-age');
        }
       
      });
  }

  ngOnDestroy() {
    this.languageSubscription && this.languageSubscription.unsubscribe();
  }

  transformHotelRemarkForDisplay() {
    this.hotelRemarksDisplay = []
    for (let i = 0 ; i < this.hotelRemarks.length ; i++) {
      const remark = this.appConfigService.getLanguage() === Language.th ? this.hotelRemarks[i].th : this.hotelRemarks[i].en;
      if (remark != null) {
        const remarkModified = remark.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
        this.hotelRemarksDisplay.push(remarkModified);
      }
    } 
  }

  transformChildPolicyForDisplay() {
    this.childPolicyDisplay = []
    for (let i = 0; i < this.childPolicies.length; i++) {
      const childPolicy = new ChildPolicyDislay();
      if (this.childPolicies[i].isInfant) {
        childPolicy.policy = this.replaceFromTo('child-policy-infant-policy', this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
        childPolicy.stayFree = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-stay-description' : 'child-policy-stay-description');
        childPolicy.description = this.translate.transform('child-policy-infant-description');
      } else {
        childPolicy.description = this.translate.transform('child-policy-adult-description');
        if (this.childPolicies[i].ageTo) {
          childPolicy.policy = this.replaceFromTo('child-policy-child-policy', this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
          childPolicy.stayFree = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-stay-description' : 'child-policy-stay-description');
        } else {
          childPolicy.policy = this.replaceFromTo('child-policy-adult-policy',this.childPolicies[i].ageFrom, this.childPolicies[i].ageTo);
        }
        childPolicy.description = this.translate.transform(this.childPolicies[i].isFree ? 'child-policy-free-description' : 'child-policy-description');
      }
      this.childPolicyDisplay.push(childPolicy);
    }
  }

  replaceFromTo(text: String, from, to): String {
    let val = this.translate.transform(text);
    from !== undefined && (val = val.replace(/{from}/g, from));
    to !== undefined && (val = val.replace(/{to}/g, to));
    return val;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/hotel-remark-information/hotel-remark-information.component.ts